import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstants } from 'src/app/common/constants/app-constants';
import { HttpClientService } from 'src/app/common/services/http-client-service';
import { UserCacheService } from 'src/app/common/services/user-cache.service';
import { ApiNameList } from 'src/environments/api-name-list';
import { AppConfigService } from 'src/app/main/app-config.service';

@Injectable()
export class NewEnrollmentService {
    public baseUrl = '';
    public environment: any;
    constructor(public httpClientService: HttpClientService, private userCacheService: UserCacheService, private appConfigService: AppConfigService) {
        this.environment = this.appConfigService.getConfig();
        this.baseUrl = ApiNameList.restApi.baseUrl;
    }

    initEnrollment(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.initEnrollment, request);
    }

    enrollmentInfo(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.enrollmentInfo, request);
    }
    getPaymentInfo(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.paymentInfo, request);
    }

    addressValidation(request: any): any {
        let headers = new HttpHeaders();
        headers = headers.set('userid', this.userCacheService.getUserData(AppConstants.USERID) ?? '');
        headers = headers.set('authorization', this.userCacheService.getUserData(AppConstants.TOKEN) ?? '');
        headers = headers.set('clientcorrelationid', this.userCacheService.getUserData(AppConstants.CLIENT_CORRELATION_ID) ?? '');
        headers = headers.set('Content-Type', 'application/json');
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.addressValidation, request, headers);
    }

    getDependents(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getDependents, request);
    }
    manageDependents(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.manageDependents, request);
    }

    enrollmentReview(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.enrollmentReview, request);
    }
    updateEnrollments(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.updateMyDetails, request);
    }

    submitEnrollments(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.submitEnrollment, request);
    }

    getEnrollmentById(request: any): any {
        return this.httpClientService.post(this.baseUrl + ApiNameList.restApi.getEnrollmentById, request);
    }
}